import polyglotI18nProvider from 'ra-i18n-polyglot';
import en from 'ra-language-english';
import de from './i18n/de'

const translations = { en, de };

export const i18nProvider = polyglotI18nProvider(
    locale => translations[locale],
    'de', // default locale
    [
        { locale: 'de', name: 'Deutsch' },
        { locale: 'en', name: 'English' }
    ],
);
